module.exports = __webpack_public_path__ + "static/media/MHei-Light.d4136b50.svg";